import { useState } from "react"
import { Link } from "react-router-dom"

//functions
import NumberToMoney from '../../../../shared/functions/NumberToMoney'

/* form */
import Input from "../../../../shared/components/form/input"
import FormLayout from "../../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../../shared/components/FormLayout/FormSection"
import Button from "../../../../shared/components/Button/Button"

function FormCost({ handleSubmit, costData, btnText, btCancelLink, btCancelAction, title }) {

    const [cost, setCost] = useState(() => costData ? { ...costData, cost: NumberToMoney(costData.cost) } : {})

    function handleChange(e) {
        setCost({ ...cost, [e.target.name]: e.target.value })
    }

    /* ----------------- function  money 0.00 ------------------- */
    function handleChangeMoney(e) {
        let value = NumberToMoney(e.target.value)
        setCost({ ...cost, [e.target.name]: value })
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit(cost)
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection>
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Descrição (opcional)"
                            type="text"
                            name="description"
                            placeholder="Ex: algodão penteado"
                            handleOnChange={handleChange}
                            value={cost.description || ''}
                        />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Quantidade mínima"
                            type="number"
                            name="minUnit"
                            placeholder="Quantidade mínima"
                            handleOnChange={handleChange}
                            value={cost.minUnit ?? ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Quantidade máxima"
                            type="number"
                            name="maxUnit"
                            placeholder="Quantidade máxima"
                            handleOnChange={handleChange}
                            value={cost.maxUnit ?? ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Custo"
                            type="number"
                            name="cost"
                            placeholder="Custo"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={cost.cost ?? ''}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormCost
